import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { ScorePage } from '../pages/score/score';
import { SettingsPage } from '../pages/settings/settings';
import { RegisterPage } from '../pages/register/register';

import { LoginPage } from '../pages/login/login';
import {AngularFireAuth} from 'angularfire2/auth';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  pages: Array<{title: string, component: any, icon: string}>;

  constructor(private afauth: AngularFireAuth, private db: AngularFireDatabase) {


    this.pages = [
      { title: 'Admin Dashboard', component: HomePage, icon: 'home'},
      { title: 'Questions Manager', component: ListPage, icon: 'clipboard'},
      { title: 'Game Settings', component: SettingsPage, icon: 'settings' },
      {title: 'Sign out', component: null, icon: 'log-out'}
    ];

    const authObserver = afauth.authState.subscribe( user => {
      if (user) {



        this.db.object('/v2/users/' + this.afauth.auth.currentUser.uid + "/admin")
        .subscribe(data =>{

          if(data.$value)
          {
            this.rootPage = HomePage;
            authObserver.unsubscribe();

          }
          else
          {
            this.rootPage = ScorePage;
            authObserver.unsubscribe();
          }
        });


      } else {
        this.rootPage = LoginPage;
        authObserver.unsubscribe();
      }
    });

  }

  openPage(page) {

     
    if(page.component == null)
    {
       this.afauth.auth.signOut();
       this.db.database.goOffline();
       this.nav.setRoot(LoginPage);

    }else
    {
        this.nav.setRoot(page.component);

    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts